import { HTTP } from "../../../http-common";
import { handset } from "../../../models/handset";
import { hardware } from "../../../models/hardware";
import { getField, updateField } from "vuex-map-fields";
import { httpError } from "../../../models/httpError";
import { hardwareOrder } from "../../../models/HardwareOrder";

const state = {
  hardwareOrder: new hardwareOrder(),
  handsets: [new handset()],
  rows: [],
  message: new httpError(),
};

//getters

const getters = {
  getField,
};

//Mutations
const mutations = {
  setHardwareOrder(state, order) {
    if (order === "") state.hardwareOrder = new hardwareOrder();
    else state.hardwareOrder = order;
  },
  setHandset(state, handsets) {
    state.handsets = handsets;
  },
  clearRows(state) {
    // state.rows.length = 0;
    state.rows = [];
  },
  setRows(state, rows) {
    state.rows.length = 0;
    rows.forEach((data) => {
      state.rows.push(data);
    });
  },
  setProgress(state, message) {
    state.message = message;
  },
  addRow(state) {
    state.rows.push(new hardware({ quantity: 1, fromIPOrder: false }));
  },
  deleteRowByID(state, hardwareID) {
    let index = state.rows.findIndex((x) => x.hardwareID == hardwareID);
    if (index > -1) {
      state.rows.splice(index, 1);
    }
  },

  updateField,
};

//ACTIONS
const actions = {
  reset({ commit }) {
    commit("setHardwareOrder", new hardwareOrder());
    commit("clearRows");
    commit("setProgress", new httpError());
  },
  setMessage({ commit }, message) {
    commit("setProgress", message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit("setProgress", new httpError());
      }, 2000);
  },

  getHandsetsFromIPVoice({ commit, rootState }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.get(
        "order/GetHandsetsOffOrder/" + rootState.orders.rows[0].orderID
      );
      response
        .then(async (data) => {
          commit("setRows", data.data);
          resolve(data.data);
        })
        .catch((err) => {
          commit("setRows", [new hardware()]);
          reject(err);
        });
    });
  },
  getHandsetsOnOrder({ commit, dispatch, state, rootState }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.get(
        "Order/getHardwareOnOrder/" + rootState.orders.rows[0].orderID
      );
      response
        .then(function (data) {
          if (data.status === 200) {
            var resultData = data.data;
            commit("setRows", resultData.lines);
            commit("setHardwareOrder", resultData.summary);
            resolve(resultData);
          } else {
            if (typeof state.rows === "undefined") {
              commit("setRows", [new hardware()]);
              resolve();
            }
          }
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({ message: "Error:" + err, httpStatus: 200 })
          );
          reject(err);
        });
    });
  },

  getHardware({ commit, dispatch, rootState }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.get(
        "Order/getHardwareOrder/" + rootState.orders.rows[0].orderID
      );
      response
        .then(async function (data) {
          var resultData = data.data;
          await dispatch("getHandsetsOnOrder");
          commit("setHardwareOrder", resultData);
          dispatch(
            "setMessage",
            new httpError({ message: "Hardware Retreived", httpStatus: 200 })
          );
          resolve(resultData);
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({ message: "Error:" + err, httpStatus: 200 })
          );
          reject(err);
        });
    });
  },

  getHandsets({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.get("Order/getHandsets/", "");
      response
        .then(function (data) {
          var resultData = data.data;
          commit("setHandset", resultData);
          resolve(resultData);
          return;
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({ message: "Error:" + err, httpStatus: 200 })
          );
          reject(err);
        });
    });
  },
  saveHardware({ commit, dispatch, state, rootState }, { orderID = null, hardwareOrder = null }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post(
        `order/CreateHardwareOrder/${orderID ? orderID : rootState.orders.rows[0].orderID}`, hardwareOrder ? hardwareOrder :
        state.hardwareOrder
      );
      response
        .then((data) => {
          if (data.status === 200) {
            commit("setHardwareOrder", data.data);
            commit("orders/setHardware", data.data.hardwareOrderID, {
              root: true,
            });
            dispatch(
              "setMessage",
              new httpError({ message: "Saved OK", httpStatus: 200 })
            );
          }
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({ message: err.response.message, httpStatus: 500 })
          );
          reject(err);
        });
    });
  },
  saveHandsets({ commit, dispatch, state }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post(
        "order/AddHardwareToOrder/" + state.hardwareOrder.hardwareOrderID,
        state.rows
      );
      response
        .then((data) => {
          if (data.status === 200) {
            commit("clearRows");
            commit("setRows", data.data);
            dispatch(
              "setMessage",
              new httpError({ message: "Saved OK", httpStatus: 200 })
            );
          }
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({ message: err.response.message, httpStatus: 500 })
          );
          reject(err);
        });
    });
  },
  deleteRow({ commit, rootState }, hardwareID) {
    return new Promise((resolve, reject) => {
      var response = HTTP.delete(
        "order/RemoveHardwareOnOrder/" + rootState.orders.rows[0].orderID,
        { data: [hardwareID] }
      );
      response
        .then((data) => {
          commit("deleteRowByID", hardwareID);
          resolve(data.data);
        })
        .catch((err) => {
          //   commit('setRows', [new hardware()]);
          reject(err);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
